import { useSettings } from 'app/hooks/useSettings'
import type { NavGate, NavItemsInput, NavListsSetting } from 'app/types/navigation'
import {
  EMPTY_NAV_LISTS_SETTING,
  buildNavListEntries,
  listRecordTypes,
  manualListGates,
  navListsSettingKey,
  pruneNavListsSetting,
  visibleNavLists,
} from 'lib/navLists'
import { isNavItemVisible } from 'lib/navVisibility'
import type { NavItemType } from 'types/Sidebar'

export function useNavLists(input: NavItemsInput, gate: NavGate | undefined, loading: boolean) {
  const settingKey = navListsSettingKey(input.workspace?.id)
  const [stored, saveSetting, settingLoaded] = useSettings<NavListsSetting>(settingKey)
  const entries = gate ? buildNavListEntries(input, gate) : []
  const setting: NavListsSetting = { ...EMPTY_NAV_LISTS_SETTING, ...stored }
  // Pruning before the custom pages or the Lists have loaded would erase their saved positions.
  const canPrune = !!gate && !loading
  // Offering a manual list is the same question as showing one, asked before any exists.
  const manualListProbe: NavItemType = { name: `Manual list`, ...manualListGates(input) }

  return {
    entries,
    recordTypes: gate ? listRecordTypes(input, gate) : [],
    canCreateManualList: gate ? isNavItemVisible(manualListProbe, gate) : false,
    setting,
    settingLoaded,
    save: (next: NavListsSetting) => saveSetting(settingKey, canPrune ? pruneNavListsSetting(next, entries) : next),
    ...visibleNavLists(entries, setting),
  }
}
